import { Record } from 'immutable';
import { ASSOCIATED_TICKET_REMOVAL } from '../constants/overlayTypes';
const TicketAssociationRemovalOverlay = Record({
  audit: null,
  type: ASSOCIATED_TICKET_REMOVAL
}, 'TicketAssociationRemovalOverlay');
export default TicketAssociationRemovalOverlay;